import { useCallback, useRef } from 'react';
import { useIntl } from 'react-intl';
import { fetchBudgetServiceItemsV2 } from '../../../../../api/fetchBudgetV2';
import BudgetSelectCustom from '../../BudgetSelectCustom';
import { IBudgetServiceItem } from '../../../../../models/budgetV2';

interface IBudgetDescriptionSelectProps {
  value: string;
  onChange: (option: IBudgetServiceItem | undefined) => void;
  disabled?: boolean;
  isRemoved?: boolean;
  autoFocus?: boolean;
}

export const BudgetDescriptionSelect = (props: IBudgetDescriptionSelectProps) => {
  const intl = useIntl();

  const allDataRef = useRef<IBudgetServiceItem[]>([]);

  const loadDescriptionData = useCallback(
    async (
      searchTerm: string,
      pageSize: number,
      page: number,
    ): Promise<IBudgetServiceItem[]> => {
      try {
        const items = (await fetchBudgetServiceItemsV2({ searchTerm, limit: pageSize, page })).filter((item) => item.description);

        if (page === 1) {
          allDataRef.current = items;
        }
        return items;
      } catch (error) {
        if (page === 1 && allDataRef.current.length > 0) {
          return allDataRef.current;
        }
        return [];
      }
    },
    [],
  );

  return (
    <BudgetSelectCustom
      value={props.value ? [props.value] : []}
      onChange={props.onChange}
      loadData={loadDescriptionData}
      getOptionLabel={(option) => option.item ? `${option.description || ''} (${option.item})` : (option.description || '')}
      loadOnFocus
      disabled={props.disabled}
      isRemoved={props.isRemoved}
      autoFocus={props.autoFocus}
      openOnFocus={false}
      initialLimit={10}
      placeholder={intl.formatMessage({ id: 'intl-msg:budgets.searchByDescription' })}
      inputBorderColor="#14b8a6"
      inputBackgroundColor="#ffffff"
      dropdownBackgroundColor="#ffffff"
      highlightedOptionColor="#3b82f6"
      selectedOptionColor="#e5e7eb"
    />
  );
};

